// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dSef","fullView":"styles_fullView__1mXDP"};